import React from 'react';
import { motion } from 'framer-motion';
import { Search, Book, MessageCircle, FileText, ArrowRight } from 'lucide-react';
import Button from '../components/ui/Button';

const HelpCenter: React.FC = () => {
  const categories = [
    {
      title: 'Getting Started',
      icon: <Book className="h-6 w-6" />,
      articles: [
        'How to create an account',
        'Complete your profile',
        'Take the career assessment',
        'Understanding your results'
      ]
    },
    {
      title: 'Account & Settings',
      icon: <FileText className="h-6 w-6" />,
      articles: [
        'Update account information',
        'Change password',
        'Notification preferences',
        'Privacy settings'
      ]
    },
    {
      title: 'Features & Tools',
      icon: <MessageCircle className="h-6 w-6" />,
      articles: [
        'Using the career simulator',
        'Finding mentors',
        'Applying for scholarships',
        'Skill development tracking'
      ]
    }
  ];

  return (
    <main className="bg-gray-50 min-h-screen py-12">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-4xl mx-auto"
        >
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">How can we help you?</h1>
            <p className="text-xl text-gray-600 mb-8">
              Search our help center or browse categories below
            </p>
            
            <div className="relative max-w-2xl mx-auto">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
              <input
                type="text"
                placeholder="Search help articles..."
                className="input pl-12 py-4 text-lg w-full"
              />
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {categories.map((category, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md"
              >
                <div className="flex items-center mb-4">
                  <div className="p-2 bg-primary-100 rounded-lg text-primary-600 mr-3">
                    {category.icon}
                  </div>
                  <h2 className="text-xl font-bold text-gray-900">{category.title}</h2>
                </div>
                <ul className="space-y-3">
                  {category.articles.map((article, articleIndex) => (
                    <li key={articleIndex}>
                      <a
                        href="#"
                        className="flex items-center text-gray-600 hover:text-primary-600 transition-colors"
                      >
                        <ArrowRight className="h-4 w-4 mr-2" />
                        {article}
                      </a>
                    </li>
                  ))}
                </ul>
                <Button
                  variant="outline"
                  fullWidth
                  className="mt-6"
                >
                  View All
                </Button>
              </motion.div>
            ))}
          </div>

          {/* Need More Help Section */}
          <div className="bg-primary-900 text-white rounded-lg p-8 text-center">
            <h2 className="text-2xl font-bold mb-4">Still need help?</h2>
            <p className="text-primary-100 mb-6">
              Our support team is available to assist you with any questions or concerns.
            </p>
            <Button
              variant="outline"
              className="bg-transparent border-white text-white hover:bg-white hover:text-primary-900"
            >
              Contact Support
            </Button>
          </div>
        </motion.div>
      </div>
    </main>
  );
};

export default HelpCenter;